<template>
  <div>
    <BaseFrame
      cancelText="取消"
      clearText=""
      submitText="提交"
      @submit="handleSubmit"
    >
      <div class="container" slot="content">
        <lk-card>
          <lk-form :model="goodsInfo" :label-width="100" :rules="formRules" ref="form">
            <lk-form-item label="第三方平台：" prop="type">
              <lk-select v-model="goodsInfo.type" class="defaultWidth" :disabled="isEdit">
                <lk-option v-for="item in thirdPartyList" :key="item.id" :value='item.id'>{{item.name}}</lk-option>
              </lk-select>
            </lk-form-item>
            <lk-form-item label="商品：">
              <inputSearch
                v-model.trim="goodsInfo.searchContent"
                :columns='searchGoodsColumns'
                @getData='toGetDrugData' 
                :data='searchData'
                @selected='handleSelect'
                :reset='false'
                :inputDisabled="disabled || isEdit"
                :maxlength='35'
                style="width:200px;"
                class="margin-left"
              ></inputSearch>
              <div>
                <lk-table border :columns='searchColumns' :data='tableSelectData'></lk-table>
              </div>
            </lk-form-item>
            <lk-form-item label="转换系数:" prop="num">
              <lk-input-number 
                v-model.trim="goodsInfo.num" 
                placeholder="请输入正整数"
                :min="1"
                :active-change="false"
                @on-change="handleNumChange"
                :disabled="isEdit"
                class="defaultWidth"
              >
              </lk-input-number>
            </lk-form-item>
            <lk-form-item label="SKUID:" prop="skuId">
              <lk-input v-model.trim="goodsInfo.skuId" class="defaultWidth" :disabled="isEdit"></lk-input>
            </lk-form-item>
            <lk-form-item label="SKU名称:" prop="skuName">
              <lk-input v-model.trim="goodsInfo.skuName" class="defaultWidth" :maxlength="50"></lk-input>
            </lk-form-item>
            <lk-form-item label="SKU销售价格:" prop="discountType">
              <lk-radio-group v-model="goodsInfo.discountType" @on-change="handleRadioChange">
                <lk-radio :label="1">固定优惠</lk-radio>
                <lk-radio :label="2">折扣</lk-radio>
              </lk-radio-group>
              <div style="display:flex;align-items:center;">
                <input class="defaultWidth" v-model="msg" :disabled="true" style="text-align:center;"></input>
                <span style="font-size:20px;">{{goodsInfo.discountType == 1 ? '-' : '*'}}</span>
                <lk-input-number class="defaultWidth"
                  v-if="goodsInfo.discountType == 1"
                  v-model="goodsInfo.discount"
                  :precision="2"
                  :active-change="false">
                </lk-input-number>
                <lk-input-number class="defaultWidth"
                  v-if="goodsInfo.discountType == 2"
                  v-model="goodsInfo.discount"
                  :min="0.001"
                  :max="1"
                  :precision="3"
                  :active-change="false">
                </lk-input-number>
              </div>
            </lk-form-item>
            <lk-form-item label="SKU包装规格:" prop="specifications">
              <lk-input v-model="goodsInfo.specifications" class="defaultWidth" :maxlength="50" :disabled="isEdit"></lk-input>
            </lk-form-item>
            <lk-form-item label="SKU包装单位:" prop="minPkgUnit">
              <lk-input v-model="goodsInfo.minPkgUnit" class="defaultWidth" :maxlength="50" :disabled="isEdit"></lk-input>
            </lk-form-item>
            <lk-form-item label="推送门店:" prop="storeIdList">
              <lk-select v-model="goodsInfo.storeIdList" class="defaultWidth" :multiple="true" :disabled="isEdit">
                <lk-option v-for="item in storeList" :key="item.storeId" :value='item.storeId'>{{item.storeName}}</lk-option>
              </lk-select>
            </lk-form-item>
          </lk-form>
        </lk-card>
      </div>
    </BaseFrame>
  </div>
</template>
<script>
import BaseFrame from '../../components/frame/BaseFrame.vue';
import inputSearch from '../../components/InputSearch.vue';
import tools from '../../services/tools';
import goods from '../../services/goods';
import utils from '../../libs/utils';

export default {
  name: 'goodsTothirdPartyAdd',
  components: {
    BaseFrame,
    inputSearch
  },
  computed: {
    disabled() {
      return this.tableSelectData.length > 0;
    }
  },
  data() {
    return {
      isEdit: false,
      msg: '门店原价 * 转换系数',
      thirdPartyList: [
        {
          id: 1,
          name: '药联'
        }
      ],
      goodsInfo: {
        searchContent: '',
        type: '',
        storeIdList: [],
        skuId: '',
        skuName: '',
        num: 1,
        discountType: 1,
        discount: 0,
        specifications: '',
        minPkgUnit: '',
        goodsBaseId: '',
        serialCode: '',
      },
      formRules: {
        type: [{ required: true, message: '请选择第三方平台', type: 'number', trigger: 'change' }],
        num: [{ required: true, message: '请输入转换系数',  trigger: 'change', type: 'number' }],
        skuId: [{ required: true, message: '请输入SKUID',  trigger: 'change' }],
        skuName: [{ required: true, message: '请输入SKU名称',  trigger: 'change' }],
        discountType: [{ required: true, message: '请选择SKU销售价格',  trigger: 'change', type: 'number' }],
        specifications: [{ required: true, message: '请输入SKU包装规格',  trigger: 'change' }],
        minPkgUnit: [{ required: true, message: '请输入SKU包装单位',  trigger: 'change' }],
        storeIdList: [{ required: true, message: '请选择推送门店',  trigger: 'change', type: 'array' }],
      },
      storeList: [],
      searchData: [],
      tableSelectData: [],
      searchGoodsColumns: [
        { title: '商品编码', key: 'drugSerialCode', width: '50px' },
        { title: '通用名', key: 'approvedDrugNames', width: '120px' },
        { title: '商品名', key: 'goodsName', width: '100px' },
        { title: '规格', key: 'specifications', width: '80px' },
        { title: '生产企业', key: 'manufacturer', width: '110px' },
        { title: '批准文号/注册证号', key: 'approvalNumber', width: '100px' },
      ],
      searchColumns: [
        { title: '基础商品编码', key: 'drugSerialCode', minWidth: 116 },
        { title: '通用名', key: 'approvedDrugNames', minWidth: 116 },
        { title: '商品名', key: 'goodsName', minWidth: 116 },
        { title: '包装规格', key: 'specifications', minWidth: 116 },
        { title: '包装单位', key: 'drugMiniPackageUnitString', minWidth: 116 },
        { title: '生产企业', key: 'manufacturer', minWidth: 116 },
        { title: '批准文号/注册证号', key: 'approvalNumber', minWidth: 116 },
        { 
          title: '操作',
          minWidth: 116,
          render: (h, params) => h('div', [
            h('lk-button', {
              props: {
                type: 'text',
                size: 'small',
              },
              on: {
                click: () => {
                  this.goodsInfo.goodsBaseId = "";
                  this.goodsInfo.serialCode = "";
                  this.tableSelectData.splice(params.index, 1);
                }
              }
            }, '删除')
          ])
        },
      ],
    }
  },
  methods: {
    handleRadioChange(val) {
      if (val === 1) {
        this.goodsInfo.discount = 0;
      } else {
        this.goodsInfo.discount = 1;
      }
    },
    handleNumChange() {
      this.goodsInfo = Object.assign(this.goodsInfo, {
        skuId: '',
        skuName: '',
        specifications: '',
        minPkgUnit: '',
      })
    },
    async handleSubmit() {
      const result = await this.formValidate();
      if (!result) return
      if (!this.goodsInfo.goodsBaseId || !this.goodsInfo.serialCode) {
        this.$Message.error('请先选择添加的商品');
        return
      }
      if (this.goodsInfo.storeIdList.includes(0)) {
        this.goodsInfo.storeIdList = [];
      }
      let submit = this.isEdit ? tools.toThirdEditGood : tools.toThirdAddGood;
      const params = utils.deepClone(this.goodsInfo);
      if (this.isEdit) {
        params.id = this.$route.params.id;
      }
      submit(params).then(res => {
        if (res.data.status === 200) {
          this.$Message.success('保存成功');
          this.$router.push({ name: 'goodsTothirdParty' });
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch(err => {
        utils.handleError(err);
      })

    },
    formValidate() {
      return new Promise(resolve => {
        this.$refs.form.validate(valid => resolve(valid))
      })
    },
    toGetDrugData() {
      const params = {
        nameMix: this.goodsInfo.searchContent,
        page: 1,
        size: 100,
      };
      goods.listGoodsBases(params).then(res => {
        if (res.data.status === 200) {
          this.searchData = res.data.data.list.map(item => item.goodsBase)
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch(err => {
        utils.handleError(err);
      })
    },
    toGetStores(id) {
      tools.toThirdSearchStore({ goodsBaseId: id }).then(res => {
        if (res.data.status === 200) {
          this.storeList = res.data.data;
          if (this.storeList.length) {
            this.storeList.unshift({ storeName: '所有门店', storeId: 0 });
          }
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch(err => {
        utils.handleError(err);
      })
    },
    handleSelect(obj) {
      this.tableSelectData = [obj];
      this.storeList = [];
      this.toGetStores(obj.id);
      this.goodsInfo = Object.assign(this.goodsInfo, {
        num: 1,
        skuId: `${obj.id}`,
        skuName: obj.goodsName || '',
        specifications: obj.specifications || '',
        minPkgUnit: obj.drugMiniPackageUnitString || '',
        goodsBaseId: obj.id,
        serialCode: obj.drugSerialCode || '',
      })
    },
    toFetchData(id) {
      tools.searchGoods({ id }).then(res => {
        if (res.data.status === 200) {
          let data = res.data.data;
          this.goodsInfo = Object.assign(this.goodsInfo, {
            type: data.type,
            storeIdList: [data.storeId],
            skuId: data.skuId,
            skuName: data.skuName,
            num: data.num,
            discountType: data.discountType,
            discount: data.discount,
            specifications: data.specifications,
            minPkgUnit: data.minPkgUnit,
            goodsBaseId: data.goodsBaseId,
            serialCode: data.serialCode,
          })
          this.toGetStores(this.goodsInfo.goodsBaseId);
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch(err => {
        utils.handleError(err);
      })
    }
  },
  mounted() {
    if (this.$route.params.id) {
      this.isEdit = true;
      this.toFetchData(this.$route.params.id);
    }
  }
}
</script>
<style lang="less" scoped>
  .defaultWidth {
    width: 200px;
  }
</style>